import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get, filter, forEach, isEmpty } from "lodash";

import { Dialog } from "@material-ui/core";
import ComplexRailcar from "./ComplexRailcar";

import { ReactComponent as NoteIcon }  from "./assets/note.svg";
import { ReactComponent as OverrideIcon }  from "./assets/override.svg";
import { ReactComponent as PhotosIcon }  from "./assets/photos.svg";
import { ReactComponent as VerifyIcon }  from "./assets/verify.svg";

import { ReactComponent as Placeholder }  from "./assets/placeholder.svg";
import Close from "@material-ui/icons/Close";
import Picture from "../Common/Picture";
import colors from "../../assets/style/colors";
import CorrectConfirmValue from "../SiteEntranceExit/CorrectConfirmValue/CorrectConfirmValue";

import { fetchPostAbort } from "../../api/fetch";
import EventsDialog from "../Events/EventsDialog";
import { minifyRailcar } from "./HelperFunctions";

import { eventGroupsData } from "../../constants/eventGroups"
import { EVENT_TYPE } from "../../constants/events";
import { 
  FACE_DETECT, 
  HUMAN_DETECT, 
  HUMAN_EXIT,
  CONTEXT,
  CONTEXT_LPR,
  CONTEXT_OCR,
  OCR,
  LPR,
} from "../../constants/common";

import { getLov } from "../../utils/lov";
import { getOverrideEvent } from "../../utils/eventGroups";
import {
  getOcrGroupedByPhotos,
  getLprDetails,
  getContextPhotosWithRoi,
} from "../../utils/detectionDetails";
import { getOcrLprConfirmationCorrection } from "../../utils/event";
import { isUnknownProfile } from "../../utils/profile";

import {
  updateOneLog,
} from "../../actions/siteEntranceExit/tabs";

const styles = {
  trainInfoDisplay: {
    width: "375px",
    height: "481px",
    borderRadius: "4px",
    padding: "8px",
    backgroundColor: "#F8F8F8",
    border: "2px solid #D7D5C5",
    
    marginTop: "33px",
    
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    
    fontSize: "14px",
    boxSizing: "border-box",
    
  },
  trainInfoDisplayWarning: {
    backgroundColor: "#F8F8F8",
    border: "2px solid #D7D5C5",
  },

  nav: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },

  helpButton: {
    width: "24px",
    height: "24px",
    backgroundColor: "#FFEB3B",
    fontWeight: "bold",
    textAlign: "center",
    borderRadius: "2px",
    paddingTop: "2px",
  },
  checkCompare: {
    borderRadius: "50%",
    width: "27px",
    height: "27px",
    color: "white",
    fontWeight: "500",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "5px",
    fontSize: "16px",
    paddingTop: "1px",
    userSelect: "none",
  },
  flagMatch: {
    backgroundColor: "#68ac58",
  },
  flagUnmatch: {
    backgroundColor: "#D7D5C5",
  },
  

  trainSvgIcon: {
    width: "96px",
    height: "24px",
  },

  ocrData: {
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
    height: "32px",
    width: "100%",
  },
  ocrCont: {
    marginRight: "8px",
    fontWeight: "500"
  },

  trainData: {
    width: "100%",
    height: "80px",
    backgroundColor: "white",
    display: "flex",
  },
  resultImage: {
    width: "50px",
    height: "50px",
  },

  dataSection1: {
    width: "80px",
    height: "80px",
    borderWidth: "2px",
    borderStyle: "solid ",
    borderColor: "#D7D5C5",
    backgroundColor: "#F8F8F8",
    boxSizing: "borderBox",
    
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  dataSection2: {
    height: "80px",
    width: "calc(100% - 80px)",
    borderWidth: "2px 2px 2px 0px",
    borderStyle: "solid ",
    borderColor: "#D7D5C5",
    boxSizing: "borderBox",
    padding: "4px 4px 0px 4px"
  },

  controlSection: {
    height: "60px",
    width: "60%",
    display: "flex",
    justifyContent: "space-around",
  },
  controlButton: {
    backgroundColor: "#5f00a0",
    height: "48px",
    width: "48px",
    marginRight: "4px",
    borderRadius: "2px",
    cursor: "pointer",
  },

  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "850px",
    margin: 0,
  },

  trainPhotoFeed: {
    width: "850px",
    height: "600px",
    padding: "16px"
  },
  ocrFeed: {
    width: "850px",
    height: "780px",
    padding: "16px",
  },
  trainPhotoNav: {
    display: "flex",
    justifyContent: "space-between",
  },
  correctionTitle: {
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    height: "40px", 
    borderBottom: "2px solid #5f00a0", 
    fontWeight: "500", 
    width: "100px", 
    marginBottom: "16px",
  },

  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",

    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },
  ocrContainer: {
    marginTop: "24px",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "20px 400px",


  },
  largeOCR: {
    width: "354px", 
    height: "354px", 
    border: "1px solid rgb(181,181,181)", 
    borderRadius: "2px", 
    marginTop: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    gridArea: "2 / 1 / 3 / 2",
    justifySelf: "center",
    alignSelf: "start",

  },

  potentialMatches: {
    width: "354px", 
    height: "354px", 
    display: "flex",
    justifyContent: "center",

    gridArea: "2 / 2 / 3 / 3",
    justifySelf: "center",
  },

  trainPhotoPicture: {
    textAlign: "center",
    width: "100%",
    lineHeight: "120px",
  },
  recognitionTitle: {
    color: colors.black87,
    borderBottom: "1px solid " + colors.black23,
    fontWeight: "500",
    marginBottom: "20px",
  },

  actionText: {
    color: "#5f00a0",
    fontWeight: "500",
    cursor: "pointer",
  },

};



const TrainInfoDisplay = (props) => {
  const { 
    classes, 
    language,
    dispatch,
    section,
    tabIndex,
    openFromTab,
    selectedRailcarId, 
    activeLogDetailsTab, 
    log
  } = props;  

  // Note: `Unit` in the following code refers to one of:
  // Railcar/Container/Trailer which are a subset of detectable
  // event group types.
  //
  // Staged data is data loaded when the selectedRailcarId changes
  //
  // unitData is used by CorrectConfirmValue dialog

  // TODO: selectedRecognitionPicture needs to be sourced from the capturedPhotos

  const [selectedRailcar, setSelectedRailcar] = React.useState({});
  const [complexData, setComplexData] = React.useState();
  const [stagedData, setStagedData] = React.useState();
  const [selectedUnit, setSelectedUnit] = React.useState({});
  const [selectedRecognitionPicture, setSelectedRecognitionPicture] = React.useState({})
  const [ocrCount, setOcrCount] = React.useState(0)
  const [editDialog, setOpenEdit] = React.useState(false)
  const [notesDialog, setOpenNotes] = React.useState(false)

  // States used by CorrectConfirmValue
  const [unitData, setUnitData] = React.useState();
  const [photoDetails, setPhotoDetails] = React.useState();
  const [capturedPhotos, setCapturedPhotos] = React.useState();
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    // TODO: validate that these are the correct lov's to load
    // for the train system.
    const loadLov = async () => {
      let lov = {
        107: await getLov(107),
        110: await getLov(110),
        35: await getLov(35),
        36: await getLov(36),
        42: await getLov(42),
        53: await getLov(53),
        89: await getLov(89),
        135: await getLov(135),
        tags: await getLov("tags"),
      };
      setLov(lov);
    };

    loadLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  React.useEffect(() => {
    console.log(activeLogDetailsTab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLogDetailsTab])

  React.useEffect(() => {
    if (!selectedRailcarId) return;
    if (typeof selectedUnit !== 'object') return;
    if (typeof stagedData !== 'object') return;
    // Make sure the stagedData has the selectedRailcarId as an element
    if (!Object.keys(stagedData).includes(selectedRailcarId.toString())) return;
    
    let unitId = null;
    if (Object.keys(selectedUnit).length !== 0) {
      unitId = selectedUnit.id;
    } else {
      unitId = selectedRailcarId;
    }
    // console.log('Selected eventGroupId:', unitId);
    setSelectedRecognitionPicture({ img: stagedData[unitId].contextPhotos[0].url });
    setOcrCount(stagedData[unitId].ocr?.length);
    let unitData = extractDetails(stagedData, unitId);
    setUnitData(unitData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit, stagedData, selectedRailcarId]);

  React.useEffect(() => {
    // Fetch Selected Railcar Data useEffect
    if (!selectedRailcarId) return;
    const railcarFetchAbortController = new AbortController();

    fetchRailcarData(selectedRailcarId, railcarFetchAbortController);
    setSelectedUnit({});

    return () => {
      railcarFetchAbortController.abort();
    };
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRailcarId]);

  React.useEffect(() => {
    // One of the first things to do is build the capturedPhotos structure
    if (!unitData) return;

    let photos = [];
    let photosNameSet = new Set();

    // Context photos
    unitData.contextPhotos.forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.url,
          type: CONTEXT,
          values: [],
          matched: false,
        },
        unitData.detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from LPR cropped photos
    getContextPhotosWithRoi([unitData.lpr]).forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_LPR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        unitData.detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from OCR cropped photos
    getContextPhotosWithRoi([unitData.ocr]).forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_OCR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        unitData.detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // LPR cropped photos
    unitData.lpr.forEach((rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: LPR,
          values: [rec.text],
          matched: isMatch([rec.profile]),
          //roiOverlay: [rec.roiOverlay]
        },
        unitData.detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // OCR cropped photos
    unitData.ocr.forEach((rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: OCR,
          values: rec.values,
          matched: isMatch(rec.profiles),
          //roiOverlay: [rec.roiOverlay]
        },
        unitData.detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    setCapturedPhotos(photos);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitData]);

  const fetchRailcarData = async (parentId, abortController) => {
    try {
      let body = {
        pagination: {
          limit: 2147483647,
          offset: 0,
        },
        data: eventGroupsData,
      };

      body.filter = {};
      body.filter.ids = [parentId];
      const parentEventGroup = await fetchPostAbort("new/event_groups", body, abortController.signal);

      body.filter = {};
      body.filter.parent_ids = [parentId];
      const containerEventGroups = await fetchPostAbort("new/event_groups", body, abortController.signal);

      const railcar = parentEventGroup.items[0];
      railcar.event_groups = containerEventGroups.items;
      if (railcar?.event_groups?.length > 0) {
        setComplexData(minifyRailcar(railcar));
      }
      setSelectedRailcar(railcar);

      let sd = prepStagedData(railcar);
      setStagedData(sd);

      console.log('SELECTED RAILCAR',railcar.id);
    }
    catch (e) {
      if (abortController.signal.aborted) {
        console.log("TrainInfoDisplay fetch aborted");
      }
    }
  };
  
  const prepStagedData = (railcar, containerEventGroups) => {
    // Note: stagedData[railcar.id] is the railcar itself
    //       stagedData[eg.id] are any containers/trailers on the railcar
    let stagedData = {};
    stagedData[railcar.id] = railcar;
    stagedData[railcar.id].contextPhotos = [];

    forEach(railcar.event_groups, (eg) => {
      stagedData[eg.id] = eg;
      stagedData[eg.id].contextPhotos = [];
    });

    forEach(stagedData, (sd) => {
      forEach(get(sd, ["events"]), (e) => {
        if (e.active && e.images) {
          sd.contextPhotos.push(
            ...e.images.map((i) => ({
              url: i.url,
              type:
                get(e, ["type", "id"]) === 1
                  ? HUMAN_DETECT
                  : get(e, ["type", "id"]) === 2
                  ? FACE_DETECT
                  : get(e, ["type", "id"]) === 3
                  ? HUMAN_EXIT
                  : "",
            }))
          );
        }
      });
      sd.ocr = getOcrGroupedByPhotos(sd);
      sd.lpr = getLprDetails(sd);
    });

    return stagedData
  };

  const extractDetails = (stagedData, selectedId) => {
    // the stagedData structure has all the railcar data segregated by unitId
    // the unitId is the eventGroupId of the currently selected
    // element (could be the railcar or any container/trailer on it).

    let details = {
      dacId: log.id,
      dacEventGroup: log.complete,
      detectionId: stagedData[selectedId].id,
      detectionEventGroup: stagedData[selectedId],
      log: stagedData,
      lov: lov,
      handleProfileOverride: updateRailcarLog,
      contextPhotos: stagedData[selectedId].contextPhotos || [],
      ocr: stagedData[selectedId].ocr || [],
      lpr: stagedData[selectedId].lpr || [],
      fr: stagedData[selectedId].fr || [],
      lukeIndex: stagedData[selectedId].luke_index,
      override: getOverrideEvent(stagedData[selectedId]),
    };
    return details;
  };

  const updateRailcarLog = () => {
    dispatch(
      updateOneLog(
        section,
        tabIndex,
        openFromTab,
        log.id
      )
    );
  };

  const isMatch = (profiles) => {
    let profile;
    if (!isEmpty(selectedUnit)) {
      profile = selectedUnit?.profile;
    } else {
      profile = stagedData[selectedRailcarId]?.profile;
    }
    let match = false;
    if (!profile || !profiles) {
      return match;
    }
    profiles.forEach((p) => {
      if (
        p &&
        !isUnknownProfile(p.id) &&
        p.id === profile.id
      ) {
        match = true;
      }
    });
    return match;
  };

  const handleSetDisplayCar = id => {
    setSelectedUnit(id ? selectedRailcar.event_groups.filter(e => e.id === id)[0] : {});
  };

  const reloadEventGroupAndFocusElement = () => {
    // Reload the event group associated with the focus element
    let selectedUnitId = selectedUnit ? selectedUnit.id : selectedRailcarId;
    let selectedPhotoUrl = photoDetails?.url;
    const railcarFetchAbortController = new AbortController();
    fetchRailcarData(selectedRailcarId, railcarFetchAbortController);
    if (selectedUnitId === selectedRailcarId) {
      setSelectedUnit({});
    } else {
      handleSetDisplayCar(selectedUnitId);
    }
    setPhotoDetails(selectedPhotoUrl ? capturedPhotos.filter(p => p.url === selectedPhotoUrl)[0]: capturedPhotos[0]);
  };

  return (
    <div className={`${classes.trainInfoDisplay}`}>
       {/* ${!selectedRailcar.profile?.name ? classes.trainInfoDisplayWarning : ""} */}
        {selectedRailcar.profile?.name ? 
        <>
        <div className={classes.nav}>
            {!selectedRailcar?.profile?.name ?
              <div className={classes.helpButton}>?</div>
              : 
              <div style={{display: "flex"}}>
                
                {typeof selectedUnit === 'object' && Object.keys(selectedUnit).length !== 0 ? 
                <>
                  <div 
                      className={`${classes.checkCompare} ${selectedUnit.attributes.filter(a => a.id === 294)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`} 
                      title={"LUKE"}>L</div>
                  <div 
                      className={`${classes.checkCompare} ${selectedUnit.attributes.filter(a => a.id === 295)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                      title={language === "en" ? "Manifest": "Manifeste"}>M</div>
                  <div 
                      className={`${classes.checkCompare} ${selectedUnit.attributes.filter(a => a.id === 296)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                      title={language === "en" ? "Sequence": "Séquence"}>S</div>
                  <div className={`${classes.checkCompare} ${selectedUnit.attributes.filter(a => a.id === 297)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                       title={"Position"}>P</div> 
                </>
                :
                <>
                  <div className={`${classes.checkCompare} ${selectedRailcar.attributes.filter(a => a.id === 294)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                      title={"LUKE"}>L</div>
                  <div className={`${classes.checkCompare} ${selectedRailcar.attributes.filter(a => a.id === 295)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                      title={language === "en" ? "Manifest": "Manifeste"}>M</div>
                  <div 
                      className={`${classes.checkCompare} ${selectedRailcar.attributes.filter(a => a.id === 296)[0].value === null ? classes.flagUnmatch : classes.flagMatch}`}
                      title={language === "en" ? "Sequence": "Séquence"}>S</div>
                </>}
              </div>
            }

            <div style={{display: "flex", flexDirection: "column"}}>
              <div className={classes}><span style={{fontWeight: "500"}}>LUKE Sequence:</span> {selectedRailcar.attributes.filter(a => a.id === 121)[0].value ? selectedRailcar.attributes.filter(a => a.id === 121)[0].value : "-"}</div>
              <div className={classes}><span style={{fontWeight: "500"}}>Manifest Sequence:</span> {selectedRailcar.attributes.filter(a => a.id === 298)[0].value ? selectedRailcar.attributes.filter(a => a.id === 298)[0].value : "-"}</div>
            </div>

        </div>

        <div style={{width: "100%"}}>
        <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
          <div style={{width: "40%", minHeight: "160px", maxHeight: "160px", overflow: "hidden"}}>
            <div>Captured</div>
            {selectedRecognitionPicture.img ?
                  <Picture style={{width: "100%"}} url={selectedRecognitionPicture.img} alt="context_image" />
                  :
                  <Placeholder alt="Result" className={classes.resultImage} />
              }

          </div>
          <div style={{width: "60%", display: "flex", justifyContent: "center", alignItems: "center"}}>
            {selectedRailcar?.event_groups?.length > 0 ? 
            <ComplexRailcar componentType={"large"} data={complexData} selectedUnitId={selectedUnit?.id} handleSetDisplayCar={handleSetDisplayCar}/>
            : null }
          </div>
        </div>
        <div className={classes.ocrData}>
          <div className={classes.ocrCont} onClick={() => setPhotoDetails(capturedPhotos[0])}> <span className={classes.actionText}>{`OCR (${ocrCount})`}</span></div>
        </div>
        {selectedRailcar?.event_groups?.length > 0 ? 
        <div><span style={{fontWeight: "500"}}>Position:</span> {selectedUnit && Object.keys(selectedUnit).length !== 0 ? selectedUnit.attributes.filter(att => att.id === 285)[0].value : "-"}</div>
        : null }
        </div>

        <div style={{display: "flex", flexDirection: "column", width: "100%", borderTop: "2px solid #D7D5C5", paddingTop: "2px"}}>
          <div>Profile</div>

          <div className={classes.trainData}>
              <div className={classes.dataSection1}>
              {selectedRailcar?.profile?.images[0] ?
                  <Picture url={selectedRailcar.profile?.images[0].url} style={{width: "100%"}}  alt="context_image" />
                  :
                  <Placeholder alt="Result" className={classes.resultImage} />
              }

              </div>
              <div className={classes.dataSection2}>
                {selectedUnit && Object.keys(selectedUnit).length !== 0 && selectedUnit.profile? 
                <div>
                  <div style={{fontWeight: "500"}}>{selectedUnit.profile.name}</div>
                  <div style={{display: "flex", alignItems: "center"}}>
                    <div style={{backgroundColor: `#${selectedUnit.profile?.tag?.color_rgb ? selectedUnit.profile.tag.color_rgb : "000"}`, width: "10px", height: "10px", borderRadius: "2px"}}></div>{selectedUnit.profile?.tag?.name_en ? selectedUnit.profile.tag.name_en : ""}
                    </div>
                  <div>{`SATC: ${selectedUnit.profile.attributes.filter(a => a.id === 292)[0].value}`}</div>
                </div>
                 : 

                 <div>
                  <div style={{fontWeight: "500"}}>{selectedRailcar?.profile?.name}</div>
                  {selectedRailcar?.profile?.tag?.color_rgb ?
                  <div style={{display: "flex", alignItems: "center"}}>
                   <div style={{backgroundColor: `#${selectedRailcar.profile.tag.color_rgb}`, width: "10px", height: "10px", marginRight: "4px", borderRadius: "2px"}}></div>{selectedRailcar.profile?.tag?.name_en ? selectedRailcar.profile.tag.name_en : ""}

                    </div>
                  : null}
                </div>
                }
              </div>
          </div>

        </div>
        
        <div className={classes.controlSection}>
            <div className={classes.controlButton} onClick={() => setPhotoDetails(capturedPhotos[0])}>
              <PhotosIcon />
            </div>
            <div className={classes.controlButton} onClick={() => setOpenNotes(true)}>
              <NoteIcon />
            </div>
            {/* <div className={classes.controlButton} style={{pointerEvents: "none"}}>
              <Verify />
            </div>
            <div className={classes.controlButton} onClick={() => setOpenEdit(true)}>
              <Override />
            </div> */}

        </div>
        
        <div style={{fontSize: "10px", width: "100%", textAlign: "right", fontStyle: "italic", color: "#444444"}}>
          <EventsDialog
            eventGroupId={selectedUnit && Object.keys(selectedUnit).length !== 0 ? selectedUnit.id : selectedRailcar.id}
            disabled={!selectedRailcar.id ? true : false}
          />
        </div>

        {/* Edit Railcar Dialog */}
        <Dialog open={editDialog} fullWidth classes={{ paper: classes.dialogPaper}} onBackdropClick={() => setOpenEdit(false)}>
          {/* <div className={classes.trainPhotoReplace}>
            <div style={{width: "300px", height: "300px", backgroundColor: "darkgray", display: "flex", justifyContent: "center", alignItems: "center"}}>

              <ComplexRailcar data={selectedRailcar} componentType={"large"}/>
              
            </div>
          </div> */}
                    
        </Dialog>
        
        {/* Notes Dialog */}
        <Dialog open={notesDialog} maxWidth={false} classes={{ paper: classes.dialogPaper}} onBackdropClick={() => setOpenNotes(false)}>
          <div className={classes.ocrFeed}>
            <div className={classes.trainPhotoNav}>
              <div style={{width:"24px", height:"24px"}}>
              </div>

              <div className={classes.correctionTitle}>
                <div>
                  {`Notes`}
                </div>

              </div>

              <div className={classes.closeButton}>
                <Close onClick={() => setOpenNotes(false)}/>
              </div>
            </div>
            
          </div>
                    
        </Dialog>

        {/* CorrectConfirmValue dialog */}
        <CorrectConfirmValue
          section={section}
          open={photoDetails != null}
          initialValue={photoDetails}
          setInitialValue={setPhotoDetails}
          close={() => setPhotoDetails(null)}
          photos={capturedPhotos ? capturedPhotos : []}
          // 8 for now but we'll need to switch to 3 or 4 for trailers and containers
          profileType={8}
          profile={get(unitData?.detectionEventGroup, ["profile"])}
          detectionEventGroup={unitData?.detectionEventGroup}
          refreshDetectionEventGroup={updateRailcarLog}
          reloadEventGroupAndFocusElement={reloadEventGroupAndFocusElement}
          dacId={get(unitData, ["dacId"], 0)}
          tabs={{
            openFrom: openFromTab,
            tabIndex: tabIndex,
          }}
        />
        </>
        : null}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(TrainInfoDisplay))

);